jQuery(document).ready(function($) {
	
	if($('.photos').length == 0)
		return;
		
	var gallery = false;
	
	var init = function() {
				
		// Breakpoint LG
		if ( $(window).width() >= 992 ) { 
			if (gallery) {
				gallery.destroy();
				gallery = false;
			}
			return;
		}
		
		// Do not re-instantiate
		if (gallery)
			return;
		
		// Instantiate
		gallery = new Swiper( '.photos .swiper-container', {
			spaceBetween: 15,
			slidesPerView: 'auto'
		} );
		
		// Bug at last slide
		gallery.on( 'transitionEnd', function() {
			if ( gallery.isEnd ) {
				$(gallery.slides).removeClass('swiper-slide-active');
				$(gallery.slides).last().addClass('swiper-slide-active');
			}
		} );
		
	}
		
	$(window).resize(init);
	
	init();
		
});